import React from 'react'
import { Box } from '@mui/material';
import { useThemeContext } from '../../context/ThemeContext';
import HeaderTwo from '../../component/header/HeaderTwo';
import Breadcrumb from '../../component/common/Breadcrumb';
import Footer from '../../component/footer/Footer';
import Notification from '../../component/common/Notification';


const NotificationPage = () => {
        const {isSM, isMd} =useThemeContext()
     
    return (
        <>
            {/* <HeaderTwo /> */}
            {/* Home > Job > Active Job */}
            
            <Box
                sx={{  
                    width:isSM? '100%' : isMd ? '100%' :'100%',
                    padding: '0',
                    backgroundColor: '#fff',
                    boxSizing: 'border-box',
                 
                }}
            >
              <HeaderTwo />
            <Breadcrumb parent='Home' title='Job' title1='Active Job' />

                <Notification/>
                <Footer />
            </Box>
          
        </>
    )
}

export default NotificationPage;